import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "../../../app/helpers";
import { RootState } from "../../../app/rootReducer";
import type { DayWorkStatus } from "../types/dashboard2-work-status.types";
import { useDashboard2WelcomeMessage } from "../hooks/useDashboard2WelcomeMessage";
import { Dashboard2SectionIntro } from "./Dashboard2SectionIntro";

type Dashboard2WelcomeBannerProps = {
  status: DayWorkStatus;
};

export const Dashboard2WelcomeBanner: React.FC<Dashboard2WelcomeBannerProps> = ({ status }) => {
  const { t } = useTranslation();
  const { firstName } = useSelector((state: RootState) => state.login.userInformation);
  const subMessage = useDashboard2WelcomeMessage(status);
  const displayName = firstName?.trim();

  const title = displayName
    ? t("_dashboard2_welcomeGreeting", { name: displayName })
    : t("_dashboard2_welcomeGreetingAnonymous");

  if (!displayName && !subMessage) {
    return null;
  }

  return (
    <Dashboard2SectionIntro
      title={title}
      description={subMessage || undefined}
      titleComponent="h1"
      density="page"
      data-testid="dashboard2-welcome-banner"
    />
  );
};
